<template>
  <Modal class="max-w-[500px]!">
    <div class="mb-4 flex items-center gap-1.5">
      <button
        type="button"
        class="-ml-1 flex size-6 items-center justify-center"
        @click="close()"
      >
        <ChevronLeftIcon class="size-5 text-gray-800" />
      </button>
      <h2 class="text-[17px] font-medium leading-[24px] text-gray-800">
        Registration details
      </h2>
    </div>

    <div class="overflow-hidden rounded-[12px] border border-[#EEEDEC]">
      <div
        class="flex h-[33px] items-center justify-between bg-[#f9f8f8] px-[14px]"
      >
        <span class="text-[12px] font-medium uppercase text-[#656666]">
          Description
        </span>
        <span class="text-[12px] font-medium uppercase text-[#656666]">
          Amount
        </span>
      </div>

      <div class="px-[14px]">
        <div
          v-for="(cost, i) in breakdown"
          :key="cost.origin?.id ?? i"
          class="border-b border-[#DFDFDF] py-[14px] last:border-b-0"
        >
          <p class="text-[13px] font-medium leading-[17px] text-gray-800">
            {{ cost.description }}
          </p>

          <div
            v-if="cost.origin && cost.origin.id !== 'Dacr'"
            class="mt-1 flex items-center gap-1.5"
          >
            <Avatar :src="cost.origin.flag?.url" :size="16" />
            <span class="text-[13px] font-medium leading-[17px] text-gray-800">
              {{ i === 0 ? 'Domestic' : 'Foreign' }}: {{ cost.origin.name }}
            </span>
          </div>

          <div class="mt-2 flex flex-col gap-1.5 pl-2.5">
            <div
              v-for="item in cost.breakdown"
              :key="item.id"
              class="flex items-center justify-between"
            >
              <span class="text-[13px] leading-[17px] text-gray-800">
                {{ item.name }}
              </span>
              <span class="text-[13px] leading-[17px] text-gray-800">
                {{ item.total.formatted }}
              </span>
            </div>

            <div class="mt-1 flex items-center justify-between">
              <span
                class="text-[13px] font-medium leading-[17px] text-gray-800"
              >
                Subtotal
              </span>
              <span
                class="text-[15px] font-medium leading-[17px] text-gray-800"
              >
                {{ cost.total.formatted }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex h-10 items-center border-t border-[#EEEDEC]">
        <span
          class="flex-1 pr-[14px] text-right text-[12px] font-medium uppercase tracking-[0.5px] text-[#656666]"
        >
          Total
        </span>
        <span
          class="flex h-full w-[116px] items-center justify-end border-l border-[#EEEDEC] pr-[14px] text-[18px] font-medium text-gray-800"
        >
          {{ estimatedCost?.total.formatted }}
        </span>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Avatar, useModal } from '@dacr/library'
import { ChevronLeftIcon } from '@dacr/icons'
import type { EstimateRegistrationCostQuery } from '@/shared/graphql/router/graphql'

const props = defineProps<{
  estimatedCost: EstimateRegistrationCostQuery['estimateRegistrationCost']
}>()

const { close } = useModal()

const breakdown = computed(() => props.estimatedCost?.breakdown ?? [])
</script>
